<template>
  <div class="content">
    <div class="info-box with-padding">
      <div class="info-hd">
        <h3>交易及退款信息</h3>
      </div>
      <div class="info-bd">
        <div class="form">
          <div class="form-item">
            <label class="label">ICCID</label>
            <div class="element">
              <span id="wxTradeNum" class="txt-box">{{detailsData.iccid}}</span>
            </div>
          </div>
          <div class="form-item">
            <label class="label">微信支付订单号</label>
            <div class="element">
              <span id="mchTradeNo" class="txt-box">{{detailsData.orderNum}}</span>
            </div>
          </div>
          <div class="form-item">
            <label class="label">套餐名</label>
            <div class="element">
              <span id="mchTradeNo" class="txt-box">{{detailsData.productName}}</span>
            </div>
          </div>
          <div class="form-item">
            <label class="label">收款账号</label>
            <div class="element">
              <p class="txt-box">
                <span id="totalRefundAmount">{{detailsData.appName}}</span>
              </p>
            </div>
          </div>
          <div class="form-item">
            <label class="label">支付方式</label>
            <div class="element">
              <p class="txt-box">
                <span id="totalRefundAmount">{{detailsData.payType}}</span>
              </p>
            </div>
          </div>
          <div class="form-item">
            <label class="label">订单金额</label>
            <div class="element">
              <p class="txt-box">
                <span id="orderTotalAmount">{{detailsData.orderMoney}}</span><span class="gapl">元</span>
              </p>
            </div>
          </div>
          <div class="form-item">
            <label class="label">已申请退款金额</label>
            <div class="element">
              <p class="txt-box">
                <span id="totalRefundAmount">{{detailsData.alreadyRefundMoney}}</span><span class="gapl">元</span>
              </p>
            </div>
          </div>
          <div class="form-item">
            <label class="label">支付平台可退金额</label>
            <div class="element">
              <p class="txt-box">
                <span id="totalRefundAmount">{{detailsData.realCanRefundPayMoney}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info-box with-padding">
      <div class="info-hd">
        <h3>退款方式</h3>
      </div>
      <div class="info-bd">
        <div class="form">
          <div class="form-item">
            <label class="label">
              <span style="color: #e15f63;font-family: SimSun;">*</span>
                选择退款方式
              </label>
            <div class="element">
              <el-radio v-model="mode" label="1">原路退回</el-radio>
              <el-radio v-model="mode" label="0">线下</el-radio>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info-box with-padding">
      <div class="info-hd">
        <h3>退款信息</h3>
      </div>
      <div class="info-bd">
        <div class="form">
          <div class="form-item">
            <label class="label">
              <span style="color: #e15f63;font-family: SimSun;">*</span>
                退款金额
            </label>
            <div class="element">
              <el-autocomplete
                class="inline-input"
                v-model="refundAmount"
                :fetch-suggestions="querySearch"
                placeholder="请输入金额"
                @focus="focusInput"
                style="width: 274px;"
              ></el-autocomplete>
              <!-- <el-input v-model="refundAmount" placeholder="请输入金额" onkeyup="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"></el-input> -->
              <span class="gapl-wide">(最多<i class="green">{{detailsData.canRefundMoney}}</i>元)</span>
            </div>
          </div>
          <div class="form-item">
            <label class="label">
              <span style="color: #e15f63;font-family: SimSun;">*</span>
              退款说明
            </label>
            <div class="element">
              <el-autocomplete
                class="inline-input"
                v-model="remark"
                :fetch-suggestions="querySearch"
                placeholder="请输入退款说明"
                @focus="focusInput2"
                style="width: 274px;"
              ></el-autocomplete>
               <!-- <el-input type="textarea" :rows="2" v-model="remark" style="width: 274px;" placeholder="请输入退款说明"></el-input> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding-bottom: 150px;">
      <el-button type="primary" size="medium" @click="submitForm()" v-if="showButton">提交申请</el-button>
    </div>
  </div>
</template>
<script>
import {refundDetail} from "@/api/api.js"; //退款的详情
import { refundRefundOrder,checkOrderAutoRenewal } from "@/api/api.js"; //数据提交
export default {
  // name: "refundDetails",
  data() {
    return {
      showButton:true,
      orderNum:'',
      mode: '1',
      refundAmount:'',
      remark:'',
      // 详情
      detailsData:{},
      restaurants:[
        { "value": "79"},
        { "value": "118.25"},
        { "value": "129"},
        { "value": "165.83"},
        { "value": "182.42"},
        { "value": "199"},
      ],
      restaurantsremark:[
        { "value": "退款销卡"},
        { "value": "用户不想要了"},
        { "value": "更换套餐"},
        { "value": "撤销补卡退款"},
        { "value": "用户重复充值"},
      ],
      focusInputVal:"",
    };
  },
  methods: {
    focusInput(){
      this.focusInputVal = "1";
    },
    focusInput2(){
      this.focusInputVal = "2";
    },
    querySearch(queryString, cb) {
      if(this.focusInputVal == "1"){
        var restaurants = this.restaurants;
      }else{
        var restaurants = this.restaurantsremark;
      }
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    // 支付方式
    transferPayType(status){
      let obj = {
        1: "微信H5支付",
        2: "微信支付",
        3: "余额支付",
        4: "系统支付",
        5: "支付宝H5支付",
        6: "贝宝支付",
        7: "佣金支付",
        8: "小程序支付",
      };
      return obj[status];
    },
    // 获取列表的数据
    initData() {
      let params = {
        orderNum:this.orderNum
      }
      refundDetail(params).then(res=>{
        if (res.data.code == 200) {
          this.detailsData = res.data.data;
          this.detailsData.payType = this.transferPayType(this.detailsData.payType)

        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    // 数据提交 
    submitForm(){
      if(this.refundAmount == "" || this.remark == ""){
        this.$message.error("请输入退款金额或退款说明");
        return
      }  
      let checkParams = {
        orderNum:this.orderNum,
      };
      this.showButton = false
      checkOrderAutoRenewal(checkParams).then(res => {
          if(res.data.data){
            this.$confirm("该订单已开通自动续费功能，退款将导致解约，是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              this.doRefundOrder();
            }).catch(() => {
              this.$message({
                type: "info",
                message: "已取消退款"
              });
            });
          } else {
            this.doRefundOrder();
          }
      }).catch(msg=>{
        this.showButton = true
      });
    },
    doRefundOrder(){
      let params = {
        orderNum:this.orderNum,
        mode:this.mode,
        refundAmount:this.refundAmount,
        remark:this.remark,
      }
      refundRefundOrder(params).then(res=>{
        this.$notify({
            title: '成功',
            message: '退款成功',
            type: 'success',
            offset:30
          });
          this.refundAmount = "";
          setTimeout(()=>{
              this.$router.go(-1)
          },200)
      }).catch(msg=>{
        this.showButton = true
      })
    }
  },
  mounted() {
    this.initData()
  },
  created() {
    this.orderNum =  this.$route.query && this.$route.query.orderNum;
  },
};
</script>
<style scoped lang="less">
.info-box {
  margin-bottom: 30px;
  border: 1px solid #EEE;
  width: 680px;
  font-size: 14px;
}
.info-box .info-hd {
  height: 38px;
  line-height: 38px;
  padding: 0 20px;
  background: #fafafa;
  border-bottom: 1px solid #EEE;
}
.info-box .info-bd {
  padding: 15px 40px;
  background: #FFFFFF;
}
.form-item {
  margin-bottom: 5px;
}
.form-item .label {
  float: left;
  width: 150px;
  padding-top: 9px;
  position: relative;
}
.form-item .element {
  margin-left: 100px;
  min-height: 42px;
  height: 42px;
  line-height: 42px;
}
.element .el-input{
  width: 274px;
}
.gapl-wide {
  margin-left: 15px;
}
.green{
  color: #00c250!important;
}
</style>


